<template>
  <b-container>
    <ProfileHero :artist="artist" v-if="artist" />
    <ArtistProfileTabs :artist="artist" v-if="artist" />

    <b-row v-if="live" class="mb-4">
      <b-col class="text-center">
        <font-awesome-icon icon="calendar-alt"></font-awesome-icon> &nbsp; {{ when }} <br>
        Duration &mdash; {{ formatDuration }}
      </b-col>
    </b-row>

    <b-row v-if="live && amAttending">
      <b-col class="player-col">
        <Player :live="live"
                :pageUrl="$route.fullPath"
                @gotBanned="gotBanned"
                @liveStreamCancelled="onStreamCancelled"
                @online="isOnline = $event"
                @liveStreamEnd="onEnd"
                @members="updateLiveViewers"
                :autoplay="true"></Player>
      </b-col>
    </b-row>
    <b-row v-if="live && !amAttending" class="upcoming">
      <b-col>
        <div class="promo">
          <img :src="live.promo_image">
          <div class="info">
            <div class="inforow">
              <img :src="live.promo_image" v-if="live">
              <div class="infocol">
                <div class="start" v-if="ended">
                  This live stream was live {{ endAt.fromNow() }}
                </div>
                <div class="start" v-else-if="started">
                  This live stream is live now
                </div>
                <div class="start" v-else-if="aboutToStart">
                  This live stream is about to start
                </div>
                <div class="start" v-else>
                  This live stream starts {{ liveStartFromNowText }}
                </div>
                <h4>{{ live.title }}</h4>
                <div class="where">
                  <i class="sl-icon-location-pin"></i> {{ live.location }}
                </div>
                <div class="act">
                  <div class="price">
                    {{ formatPrice }}
                  </div>
                  <div class="watchlist" v-if="isLoggedIn">
                    <b-button class="btn-rainbow" @click="addToWatchlist" v-if="!ticket && !amWatching && !aboutToStart">
                      <font-awesome-icon icon="plus"/> &nbsp; watchlist
                    </b-button>
                    <b-button class="btn-danger" @click="removeFromWatchlist" v-if="!ticket && amWatching && !aboutToStart">
                      <font-awesome-icon icon="minus"/> &nbsp; remove from watchlist
                    </b-button>
                    <b-button class="btn-rainbow" @click="attend" v-if="started && ticket">
                      join live stream
                    </b-button>
                  </div>
                  <div class="watchlist" v-else>
                    <b-button class="btn-rainbow"
                              :to="{name: 'account-login', query: {next: $route.fullPath}}">
                      log in to watch
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="live && live.chat_type != 'disabled' && !isOnline" class="my-2">
      <b-col>
        <CookieInfo>
          If you have trouble playing the stream, we recommend using Chrome as your browser.
          Please also ensure that your browser allows 3rd-Party cookies.
        </CookieInfo>
      </b-col>
    </b-row>

    <LiveInfo :live="live" v-if="live" @ticket="ticket = $event" @join="attend" :attending="amAttending" />

    <b-row v-if="live" class="mb-4">
      <b-col v-html="formatText(live.description)" />
    </b-row>

    <Comments :live="live" v-if="live" />
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .container {
    /* margin-top: 2em; */
    max-width: unset;
  }

  .upcoming {

    .promo {
      position: relative;
      min-height: 200px;
      @include media-breakpoint-down(sm) {
        min-height: 270px;
      }

      img {
        width: 100%;
      }

      .info {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 0;

        .inforow {
          position: relative;
          display: flex;
          align-items: start;
          padding: 1em;
          background-color: $dark-five;
          max-width: 90%;
          z-index: 2;

          img {
            display: none;
          }

          @include media-breakpoint-up(lg) {
            img {
              display: block;
              width: 200px;
              height: 113px;
              margin-right: 20px;
              box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);
            }
          }

          .infocol {

            .start {
              padding: 0.5em;
              margin-bottom: 1em;
              border-radius: 4px;
              background-color: $slate-blue;
              box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);
              text-align: center;
              @include media-breakpoint-down(xs) {
                font-size: .9em;
              }
            }

            h4 {
              margin-top: 1em;
              margin-bottom: 1em;
            }

            .act {
              margin-top: 1em;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .price {
                border-radius: 4px;
                background-color: #dc3681;
                background-color: $darkish-pink;
                padding: 0.25em 0.5em;
                margin-right: 1em;
                box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);
                @include media-breakpoint-down(xs) {
                  margin-right: .5em;
                }
              }
            }
          }

          @include media-breakpoint-up(md) {
            &:before {
              content: ' ';
              border: solid 1px $dark-five;
              position: absolute;
              top: -20px;
              left: 20px;
              width: 100%;
              height: 100%;
              z-index: -1;
            }
          }
        }
      }
    }
  }
  @include media-breakpoint-down(xs) {
    .btn-secondary {
      font-size: .8em;
    }
  }

</style>

<script>
import map from 'lodash/map'
import { mapGetters } from 'vuex'
import moment from '@/utils/moment'
import 'moment-precise-range-plugin'

import { formatText } from '@/utils/textformat'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import Player from '@/components/widgets/Player'
import ArtistProfileTabs from '@/components/widgets/ArtistProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'
import LiveInfo from '@/components/widgets/LiveInfo'
import Comments from '@/components/widgets/Comments'
import CookieInfo from '@/components/widgets/CookieInfo'

export default {
  name: 'LiveStream',
  components: {
    FontAwesomeIcon,
    Player,
    ArtistProfileTabs,
    ProfileHero,
    LiveInfo,
    Comments,
    CookieInfo
  },
  data () {
    return {
      artist: null,
      live: null,
      ticket: null,
      isOnline: false,
      refreshId: null
    }
  },
  computed: {
    endAt () {
      if (!this.live) return moment()
      return moment(this.live.start).add(this.live.duration, 's')
    },
    startAt () {
      if (!this.live) return moment()
      return moment(this.live.start)
    },
    liveStartFromNowText () {
      const fromNow = this.startAt.fromNow()
      if (['just now', 'in a few seconds'].includes(fromNow)) return 'in less than 30 seconds'
      if (fromNow === 'in a minute') return 'in about a minute'
      return fromNow
    },
    aboutToStart () {
      // Whether the stream is about to start in less than 60s
      if (!this.live) return false
      return this.startAt.subtract(60, 's').isBefore()
    },
    started () {
      return this.startAt.isBefore() && this.live && this.live.is_live
    },
    ended () {
      if (this.live && this.live.is_live) return false
      return this.endAt.isBefore()
    },
    when () {
      if (!this.live) return ''
      return moment(this.live.start).format('MMMM Do [at] h:mm a')
    },
    formatDuration () {
      if (!this.live) return ''
      const txt = moment(this.live.start).preciseDiff(this.endAt)
      return txt.replace(/ \d+ seconds?/, '')
    },
    preciseFromNow () {
      if (!this.live) return ''
      const txt = moment().preciseDiff(this.live.start)
      return txt.replace(/ \d+ seconds?/, '')
    },
    amWatching () {
      if (!this.live) return false
      return map(this.currentUser.watchlist, 'id').indexOf(this.live.id) !== -1
    },
    formatPrice () {
      if (!this.live) return ''
      if (this.ticket) return this.ticket.is_invited ? 'invited' : 'booked'
      if (this.live.price === 0) return 'free'
      if (this.live.price === null) return '$'
      return '$' + this.live.price.toFixed(2)
    },
    amAttending () {
      return this.live && this.live.is_live && !!this.live.dacast_content_id
    },
    ...mapGetters('profile', ['currentUser']),
    ...mapGetters('auth', ['isLoggedIn'])
  },
  watch: {
    '$route': 'initPage'
  },
  created () {
    this.initPage()
  },
  beforeDestroy () {
    if (this.refreshId) window.clearInterval(this.refreshId)
  },
  methods: {
    async initPage () {
      if (this.$store.getters.miniPlayer) {
        const liveInProgress = this.$store.getters.miniPlayer.getCurrentLive()
        if (liveInProgress && liveInProgress.id === parseInt(this.$route.params.liveId)) {
          this.artist = liveInProgress.artist
          this.live = liveInProgress
          return
        }
      }

      const fetchArtist = this.$store.dispatch('artist/getArtist', {id: this.$route.params.artistId})
      const fetchLive = this.$store.dispatch('live/getLiveEvent', {id: this.$route.params.liveId})

      try {
        this.artist = await fetchArtist
        this.live = await fetchLive
      } catch (e) {
        let message = 'Error getting live stream information'
        if (e.response && e.response.status === 404) message = 'The live stream no longer exists'
        this.$store.dispatch('flash/showMessage', { message, type: 'error' })
        this.$router.replace({'name': 'discover'})
        return
      }

      if (this.live.artist.id !== this.artist.id) {
        this.$router.push({name: 'artist-live-stream-list', params: {artistId: this.$route.params.artistId}})
      }

      if (!this.ended && !this.started) {
        if (this.refreshId) window.clearInterval(this.refreshId)
        this.refreshId = window.setInterval(this.refresh, 5000)
      }
    },
    async refresh () {
      if (!this.live) return
      this.live = await this.$store.dispatch('live/getLiveEvent', {id: this.$route.params.liveId})
      if (this.ended || this.started) {
        window.clearInterval(this.refreshId)
        this.refreshId = null
      }
    },
    async addToWatchlist () {
      await this.$store.dispatch('live/addToWatchlist', {id: this.$route.params.liveId})
      this.$store.dispatch('flash/showMessage', {message: 'Live stream added to watchlist'})
    },
    async removeFromWatchlist () {
      await this.$store.dispatch('live/removeFromWatchlist', {id: this.$route.params.liveId})
      this.$store.dispatch('flash/showMessage', {message: 'Live stream removed from watchlist'})
    },
    async attend () {
      if (!this.live || !this.ticket) return

      try {
        this.live = await this.$store.dispatch('live/attendLiveEvent', {id: this.live.id})
      } catch (e) {
        this.$store.dispatch('flash/showMessage', {
          type: 'error',
          message: 'Can\'t join live stream'
        })
      }
    },
    async gotBanned () {
      this.$store.dispatch('flash/showMessage', {
        type: 'error',
        message: 'You have been blocked from this live stream'
      })
      this.$router.push({name: 'artist-live-stream-list', params: {artistId: this.$route.params.artistId}})
    },
    async onEnd () {
      this.$store.dispatch('flash/showMessage', {
        message: 'The live stream has ended'
      })
      this.$router.push({name: 'artist-live-stream-list', params: {artistId: this.$route.params.artistId}})
    },
    async onStreamCancelled () {
      this.$store.dispatch('flash/showMessage', {
        message: 'The live stream has been cancelled'
      })
      this.$router.push({name: 'artist-live-stream-list', params: {artistId: this.$route.params.artistId}})
    },
    updateLiveViewers (members) {
      const count = members ? members.length : 0
      this.$set(this.live, 'viewer_count', count)
    },
    formatText
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/LiveStreamDetail.vue